<app-global-info
  icon="mdi-cloud-lock-outline"
  [title]="'unauthenticated.title' | translate"
  [description]="'unauthenticated.text' | translate"
  [showButton]="true"
  [buttonText]="'unauthenticated.actions.try-again' | translate"
  (clicked)="login()"
></app-global-info>
